import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

export const getExportRouteColumns = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.route.ExportRouteColumnsDef,
  // First argument to the payload creator
  uui.domain.actions.rpc.route.GetExportRouteColumnsPayload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/getExportRouteColumns', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/route/getExportRouteColumns', {
      category: 'rpc',
      type: 'rpc/route/getExportRouteColumns',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {getExportRouteColumns}`,
      { tags: ['rpc', 'route'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `getExportRouteColumns failed`,
      error,
    })
  }
})
